import React from 'react';
import {Input, AutoCompleteSelect} from '../../form'
import {FormTemplateField} from '../../others/'

import {CountriesStates} from '../../CountriesStates';
import { usZipCode } from '../../../components/form/FormValidations'


const Address = (props)=> {
  const {isTemplate, addressType, regions, selectedCountry, baseTemplateName, basePatientName, baseFieldValues} = props
  return(
    [<FormTemplateField
      isTemplate={isTemplate}
      isOpen={true}
      name={`${basePatientName}[address1]`}
      baseName={`${baseTemplateName}[address1]`}
      fieldValues={baseFieldValues.address1}
      component={Input} 
      className="form-control"
      wrapperClasses="col-6 form-group"
     />,
    <FormTemplateField
      isTemplate={isTemplate}
      isOpen={true}
      name={`${basePatientName}[address2]`}
      baseName={`${baseTemplateName}[address2]`}
      fieldValues={baseFieldValues.address2}
      component={Input} 
      className="form-control"
      wrapperClasses="col-6 form-group"
     />,
     <FormTemplateField
      key={`${addressType}-address-country-${selectedCountry}`} 
      isOpen={true}
      isTemplate={isTemplate}
      name={`${basePatientName}[country]`}
      baseName={`${baseTemplateName}[country]`}
      fieldValues={baseFieldValues.country}
      component={AutoCompleteSelect} 
      data={CountriesStates}  
      textField="countryName" 
      valueField= "countryName"
      wrapperClasses="col-6 form-group autocomplete"
     />,
    <FormTemplateField
      key={`${addressType}-address-state-${selectedCountry}`}
      isOpen={true}
      isTemplate={isTemplate}
      name={`${basePatientName}[state]`}
      baseName={`${baseTemplateName}[state]`}
      fieldValues={baseFieldValues.state}
      component={AutoCompleteSelect} 
      data={regions} 
      textField="name" 
      valueField= "shortCode"
      wrapperClasses="col-6 form-group autocomplete"
     />,
    <FormTemplateField
      isTemplate={isTemplate}
      isOpen={true}
      name={`${basePatientName}[city]`}
      baseName={`${baseTemplateName}[city]`}
      fieldValues={baseFieldValues.city}
      component={Input} 
      className="form-control"
      wrapperClasses="col-6 form-group"
     />,
      <FormTemplateField
        isTemplate={isTemplate}
        isOpen={true}
        name={`${basePatientName}[zip]`}
        baseName={`${baseTemplateName}[zip]`}
        fieldValues={baseFieldValues.zip}
        component={Input}
        className="form-control"
        wrapperClasses="col-6 form-group"
        validate={selectedCountry === "United States" ? [usZipCode] : []}
      />
      ]
        
  )
}
export default Address;